/**
 * Public phase share panel.
 *
 * investment_phases.total_shares_available is the pool for that phase.
 * A phase transition adds the previous phase's unsold shares to this pool.
 * investment_phases.shares_sold is the shares sold in this phase.
 * Capital raised is those shares times the phase price.
 *
 * A completed phase no longer holds its unsold shares. They were transferred
 * to the next phase, so they are not remaining inventory and they are not sales.
 */

function toNumber(value) {
  const n = typeof value === 'number' ? value : parseFloat(value)
  return Number.isFinite(n) ? n : 0
}

export function buildPhaseShareDisplay(phase, status) {
  const totalAvailable = Math.max(0, toNumber(phase?.total_shares_available))
  const recordedSold = Math.max(0, toNumber(phase?.shares_sold))
  const price = Math.max(0, toNumber(phase?.price_per_share))
  const comingSoon = status === 'Coming Soon'
  const completed = status === 'Completed'
  const sharesSold = comingSoon ? 0 : recordedSold
  const unsold = Math.max(0, totalAvailable - sharesSold)
  const percentageSold = totalAvailable > 0 ? (sharesSold / totalAvailable) * 100 : 0

  return {
    totalAvailable,
    sharesSold,
    remaining: completed ? 0 : unsold,
    transferredToNextPhase: completed ? unsold : 0,
    percentageSold,
    capitalRaised: sharesSold * price
  }
}
